import { Button } from "primereact/button";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { selectDefectsToDelete } from "../../store/selectors/defectSelectors";
import { selectInspectionIsDisabled } from "../../store/selectors/inspectionSelectors";
import { setShowDeleteSelected } from "../../store/slices/defectSlice";

export const DefectsDeleteButton = () => {
    const dispatch = useAppDispatch();

    const defects = useAppSelector(selectDefectsToDelete);
    const inspectionDisabled = useAppSelector(selectInspectionIsDisabled);

    const onDelete = useCallback(() => {
        dispatch(setShowDeleteSelected(true));
    }, [defects]);

    return (
        <Button label="Delete Selected" severity="danger" className="ml-3" onClick={onDelete} disabled={inspectionDisabled || defects.length === 0} data-cy="delete-selected-button" />
    );
}